import { install } from "./lifecycle";
install();
//# sourceMappingURL=entry.js.map